import { deprecated, ThemeNames } from '@benzinga/themetron';

import React, { CSSProperties } from 'react';
import { StockSymbol } from '../../../entities';
import { TooltipStyles } from './styles';

import { NO_VALUE } from '../../../utils/global';

const { getThemeColors } = deprecated;
export interface TooltipOptions {
  price: number;
  x: number;
  y: number;
}

interface Props {
  options: TooltipOptions;
  symbol: StockSymbol;
  theme: ThemeNames;
}

const Tooltip = ({ options, symbol, theme }: Props) => {
  const { mainColor: color, tooltipBackground } = getThemeColors(theme);

  const styles = {
    ...options,
    backgoundColor: tooltipBackground,
    color,
  };

  const safetyPrice = options.price || NO_VALUE;

  return (
    <div style={TooltipStyles(styles) as CSSProperties}>
      {symbol} {safetyPrice}
    </div>
  );
};

export default Tooltip;
